export const ADD_FREE_ACCESSORY = 'ADD_FREE_ACCESSORY';
export const GET_ALL_FREE_ACCESSORY = 'GET_ALL_FREEs';
export const REMOVE_FREE_ACCESSORY = 'REMOVE_FREE_ACCESSORY';
export const CLEAN_ACCESSORIES = 'CLEAN_ACCESSORIES';
export const UPDATE_AUTO_ELETRIC_FILTER = 'UPDATE_AUTO_ELETRIC_FILTER';
export const UPDATE_TECHNICIAN_FILTER = 'UPDATE_TECHNICIAN_FILTER';
export const UPDATE_BRANCH_FILTER = 'UPDATE_BRANCH_FILTER';
export const UPDATE_CUSTOMER_FILTER = 'UPDATE_CUSTOMER_FILTER';
export const UPDATE_APPRAISAL_FILTER = 'UPDATE_APPRAISAL_FILTER';
export const UPDATE_ATTENDING_FILTER = 'UPDATE_ATTENDING_FILTER';
export const UPDATE_ACCESSORY_LOCAL_FILTER = 'UPDATE_ACCESSORY_FILTER';
export const CLEAN_STATE = 'CLEAN_STATE';



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/actions.ts